import React, { useEffect, useState } from "react";

import CheckIcon from "@mui/icons-material/Check";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function DfrNotes({ flight }) {
    const [incident, setIncident] = useState("");
    const [location, setLocation] = useState("");
    const [summary, setSummary] = useState("");

    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(true);
    const [errorText, setErrorText] = useState("");

    useEffect(() => {
        handleInitializeData();
    }, []);

    const handleInitializeData = async () => {
        try {
            setLoading(true);

            const requestOptions = { method: "GET", headers: { "Content-Type": "application/json" } };
            const response = await fetch(`/api/dfr/get/${flight.flight_uuid}`, requestOptions);

            if (!response.ok) throw new Error(`We were unable to load notes for this flight: ${response.statusText}`);
            const text = await response.text();

            const data = text ? JSON.parse(text) : null;
            if (!data) return;

            setIncident(data.incident || "");
            setLocation(data.location || "");
            setSummary(data.summary || "");
        } catch (err) {
            console.error(err);
            setErrorText("Something went wrong while loading the previous notes for this flight.");
        } finally {
            setLoading(false);
        }
    };
    const handleSubmitButtonClick = async () => {
        try {
            setLoading(true);

            const body = {
                flight_uuid: flight.flight_uuid,
                published: false,
                incident: incident,
                location: location,
                summary: summary
            };
            const requestOptions = { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) };
            const response = await fetch(`/api/dfr/insertUpdate`, requestOptions);

            if (!response.ok) throw new Error(`An error occured during submission: ${response.statusText}`);
            setSubmitted(true);
        } catch (err) {
            console.error(err);
            setErrorText("We were unable to complete your request. Please try again later.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <Box sx={{ borderTop: "1px solid white", mt: 1 }}>
            {submitted === false ? (
                <Box sx={{ display: "flex", flexDirection: "column", p: 2, gap: 2 }}>
                    <Typography variant="body2" color="text.secondary" fontWeight="bold">
                        Notes
                    </Typography>

                    <TextField
                        label="Case / Incident"
                        value={incident}
                        onChange={(e) => setIncident(e.target.value)}
                        fullWidth
                        size="small"
                        error={errorText.length > 0}
                    />
                    <TextField
                        label="Location"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        fullWidth
                        size="small"
                        error={errorText.length > 0}
                        sx={{ width: "100%" }}
                    />
                    <TextField
                        label="Summary"
                        value={summary}
                        onChange={(e) => setSummary(e.target.value)}
                        fullWidth
                        multiline
                        minRows={3}
                        size="small"
                        error={errorText.length > 0}
                        helperText={errorText}
                    />
                    <Button variant="contained" onClick={handleSubmitButtonClick} loading={loading} size="small">
                        Save
                    </Button>
                </Box>
            ) : (
                <Box sx={{ display: "flex", flexDirection: "column", p: 2, gap: 2, textAlign: "center", alignItems: "center" }}>
                    <CheckIcon fontSize="large" color="success" />

                    <Typography variant="body1" color="text.primary">
                        Your submission was successfully saved
                    </Typography>

                    <Button onClick={() => setSubmitted(false)} size="small">
                        Close
                    </Button>
                </Box>
            )}
        </Box>
    );
}
